import type { CanadaOrderScope } from 'state/order/hooks/use-canada-order-policy';

const FEE = 399;

export type CartPreviewTotals =
  | { kind: 'canada-delivery'; amountCents: number; deliveryFeeCents: number }
  | { kind: 'canada-pickup'; amountCents: number }
  | { kind: 'unaffected'; amountCents: number };

export function resolveCartPreviewTotals(input: {
  scope: CanadaOrderScope;
  itemTotalCents: number;
  isCartEmpty: boolean;
}): CartPreviewTotals {
  const { scope, itemTotalCents, isCartEmpty } = input;

  if (scope === 'canada-delivery' && !isCartEmpty) {
    return {
      kind: 'canada-delivery',
      amountCents: itemTotalCents + FEE,
      deliveryFeeCents: FEE,
    };
  }

  if (scope === 'canada-delivery' || scope === 'canada-pickup') {
    return { kind: 'canada-pickup', amountCents: itemTotalCents };
  }

  return { kind: 'unaffected', amountCents: itemTotalCents };
}
